import React from 'react';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';
import { AiStudioRedirections } from '../types/AiStudioTypes';
import { Trans } from 'react-i18next';
import { setPreventUnload } from 'flow/actions/app-actions';

interface Props {
    redirections: AiStudioRedirections;
    openNewWindow: (url: string) => void;
    getAuthCode: () => void;
}

const ActionSection = ({ redirections, openNewWindow, getAuthCode }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="text-center lg:text-left">
            <div className="bg-green/30 text-main mb-5 inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-medium">
                {i18next.t('ai-studio.badge')}
            </div>

            <h1 className="mb-5 text-center text-3xl text-gray-900 lg:text-left">
                {i18next.t('ai-studio.hero.title')}
            </h1>

            <p className="mb-8 text-center leading-relaxed text-gray-500 max-md:mx-auto lg:text-left">
                {i18next.t('ai-studio.hero.description')}
            </p>

            <div className="mb-6 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
                <Button
                    className="bg-green rounded-xl px-5 py-3 text-white"
                    onClick={() => getAuthCode()}
                >
                    {i18next.t('login')}
                </Button>
                <Button
                    className="rounded-xl px-5 py-3 ring-1 ring-gray-400 forced-colors:outline-1"
                    onClick={() => openNewWindow(redirections?.createAccount)}
                >
                    {i18next.t('ai-studio.hero.get_cta')}
                </Button>
            </div>

            <div className="flex flex-col items-center text-center text-sm text-gray-500 lg:flex-row">
                <Trans
                    i18n={i18next}
                    i18nKey={'ai-studio.read_more.info'}
                    shouldUnescape={true}
                    components={[
                        redirections?.readMore ? (
                            // Trans puts the link text inside the <a>.
                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                            <a // NOSONAR
                                key="ai-studio-read-more"
                                href={redirections.readMore}
                                target="_blank"
                                rel="noreferrer"
                                className="focus-ring rounded-sm p-1 font-semibold text-gray-900 hover:underline"
                                // Skips the clearState on beforeunload; see TicketsIntroView.
                                onClick={() => setPreventUnload(true)}
                            />
                        ) : (
                            <span key="ai-studio-read-more" />
                        ),
                    ]}
                />
            </div>
        </div>
    );
};

export default ActionSection;
